"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillTargeterService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var SkillTargeterService = /** @class */ (function () {
    function SkillTargeterService() {
    }
    /**
     * Search
     * Based on targeter criteria, the endpoint returns a list of users
     * @param requestBody
     * @param next
     * @param limit
     * @returns QueryResponse_SkillTargeterResult_ Success
     * @throws ApiError
     */
    SkillTargeterService.search = function (requestBody, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/skill-targeter',
            query: {
                'next': next,
                'limit': limit,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Skill Targeter Statistics
     * Based on skill targeter criteria, the endpoint returns statistics about
     * the users returned by the skill targeter in:
     * - the total number of users
     * - percentiles on min and max rates
     * - expertize score histogram
     * - interaction score histogram
     * - english score histogram
     * - accent score histogram
     * - ace score histogram
     * @param requestBody
     * @param next
     * @param limit
     * @returns InternalSkillTargeterStatistics Success
     * @throws ApiError
     */
    SkillTargeterService.getSkillTargeterStatistics = function (requestBody, next, limit) {
        if (limit === void 0) { limit = 20; }
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/skill-targeter/statistics',
            query: {
                'next': next,
                'limit': limit,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Role Statistics
     * Based on a list of specialization ids in the body, the endpoint
     * returns aggregate statistics and statistics about each individual
     * specialization regarding:
     * - the total number of cases (users) found
     * - the average rate
     * - the median rate
     * - the standard deviation of the rate
     * - the minimum rate
     * - the maximum rate
     * - the percentiles in 10% increments from 0 to 100.
     * The value of the percentile denotes the rate below which the percentage of rates
     * found is equal to the percentile threshold.
     *
     * Other parameters with examples are:
     * - "countries": ["DE", "GR", "US", "CA"]
     * (list of country codes, ISO 3166-1 alpha-2,
     * will return also adjusted statistics for each country)
     * - "application_rate": true (boolean, to calculate the statistics
     * based on the min application rate)
     * - "start_date": "2020-01-01" (string, date part in ISO 8601 format,
     * calculate statistics for the period from start_date to end_date)
     * - "end_date": "2022-12-31" (string, date part in ISO 8601 format)
     * @param requestBody
     * @returns InternalRoleRateStatistics Success
     * @throws ApiError
     */
    SkillTargeterService.getRoleStatistics = function (requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/skill-targeter/role-statistics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    return SkillTargeterService;
}());
exports.SkillTargeterService = SkillTargeterService;
//# sourceMappingURL=SkillTargeterService.js.map